var _style, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path5, _circle8, _path6, _circle9, _path7, _circle0, _circle1, _path8, _path9, _path0, _circle10, _circle11, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSalt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#235EAA;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#C7C7C6;}\n\t.st3{fill:#37B6BD;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,151.26,62.06,185.55,104.75,185.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.23,84.69L75.1,144.21h60.62l-12.13-59.51H87.23z M126.81,138.66h-21.4h-21.4h-2.44l9.95-48.82h13.83h0.12 h13.83l9.95,48.82H126.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.14,80.36H83.69l-13.89,68.19h71.24L127.14,80.36z M135.72,144.21H75.1l12.13-59.51h36.37L135.72,144.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.37,78.64c0-9.52-7.75-17.27-17.27-17.27h-5.37c-9.52,0-17.27,7.75-17.27,17.27v2.17h39.91V78.64z  M116.69,70.62c1.04,0,1.89,0.85,1.89,1.89c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89 C114.79,71.47,115.64,70.62,116.69,70.62z M114.83,67.69c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89 c0-1.04,0.85-1.89,1.89-1.89C113.99,65.8,114.83,66.65,114.83,67.69z M109.14,70.62c1.04,0,1.89,0.85,1.89,1.89 c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89C107.25,71.47,108.09,70.62,109.14,70.62z M105.41,69.58 c-1.04,0-1.89-0.85-1.89-1.89c0-1.04,0.85-1.89,1.89-1.89c1.04,0,1.89,0.85,1.89,1.89C107.3,68.74,106.46,69.58,105.41,69.58z  M96.03,72.51c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89c0-1.04,0.85-1.89,1.89-1.89 C95.18,70.62,96.03,71.47,96.03,72.51z M97.94,65.8c1.04,0,1.89,0.85,1.89,1.89c0,1.04-0.85,1.89-1.89,1.89 c-1.04,0-1.89-0.85-1.89-1.89C96.05,66.65,96.9,65.8,97.94,65.8z M101.61,70.62c1.04,0,1.89,0.85,1.89,1.89 c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89C99.72,71.47,100.56,70.62,101.61,70.62z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 105.41,
    cy: 67.69,
    r: 1.89
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 97.94,
    cy: 67.69,
    r: 1.89
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 112.94,
    cy: 67.69,
    r: 1.89
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 101.61,
    cy: 72.51,
    r: 1.89
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.14,
    cy: 72.51,
    r: 1.89
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 109.14,
    cy: 72.51,
    r: 1.89
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 116.69,
    cy: 72.51,
    r: 1.89
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.47,89.84h-0.12H91.52l-9.95,48.82h2.44h21.4h21.4h2.44l-9.95-48.82H105.47z M100.96,98.35 c0.62,0,1.12,0.5,1.12,1.12c0,0.62-0.5,1.12-1.12,1.12c-0.62,0-1.12-0.5-1.12-1.12C99.83,98.85,100.34,98.35,100.96,98.35z  M99.27,109.82c0,0.68-0.55,1.23-1.23,1.23c-0.68,0-1.23-0.55-1.23-1.23s0.55-1.23,1.23-1.23 C98.72,108.59,99.27,109.14,99.27,109.82z M96.4,102.52c0,0.66-0.53,1.19-1.19,1.19c-0.66,0-1.19-0.53-1.19-1.19 c0-0.66,0.53-1.19,1.19-1.19C95.87,101.33,96.4,101.86,96.4,102.52z M94.39,94.09c0.57,0,1.02,0.46,1.02,1.02s-0.46,1.02-1.02,1.02 c-0.57,0-1.02-0.46-1.02-1.02S93.83,94.09,94.39,94.09z M92.04,106.92c0.57,0,1.02,0.46,1.02,1.02c0,0.57-0.46,1.02-1.02,1.02 c-0.57,0-1.02-0.46-1.02-1.02C91.02,107.38,91.48,106.92,92.04,106.92z M88.77,133.42c-0.57,0-1.02-0.46-1.02-1.02 s0.46-1.02,1.02-1.02c0.57,0,1.02,0.46,1.02,1.02S89.34,133.42,88.77,133.42z M91,118.59c-0.58,0-1.04-0.47-1.04-1.04 c0-0.58,0.47-1.04,1.04-1.04c0.58,0,1.04,0.47,1.04,1.04C92.04,118.12,91.58,118.59,91,118.59z M94.14,128.91 c-1.04,0-1.89-0.85-1.89-1.89c0-1.04,0.85-1.89,1.89-1.89c1.04,0,1.89,0.85,1.89,1.89C96.03,128.06,95.18,128.91,94.14,128.91z  M97.6,119.1c-0.78,0-1.4-0.63-1.4-1.4c0-0.78,0.63-1.4,1.4-1.4c0.78,0,1.4,0.63,1.4,1.4C99,118.47,98.37,119.1,97.6,119.1z  M100.68,134.09c-0.78,0-1.42-0.63-1.42-1.42c0-0.78,0.63-1.42,1.42-1.42c0.78,0,1.42,0.63,1.42,1.42 C102.1,133.46,101.47,134.09,100.68,134.09z M101.42,126.28c-1.08,0-1.95-0.87-1.95-1.95c0-1.08,0.87-1.95,1.95-1.95 c1.08,0,1.95,0.87,1.95,1.95C103.37,125.41,102.5,126.28,101.42,126.28z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.14,
    cy: 127.02,
    r: 1.89
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91,116.5c-0.58,0-1.04,0.47-1.04,1.04c0,0.58,0.47,1.04,1.04,1.04c0.58,0,1.04-0.47,1.04-1.04 C92.04,116.96,91.58,116.5,91,116.5z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 98.04,
    cy: 109.82,
    r: 1.23
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.96,100.6c0.62,0,1.12-0.5,1.12-1.12c0-0.62-0.5-1.12-1.12-1.12c-0.62,0-1.12,0.5-1.12,1.12 C99.83,100.09,100.34,100.6,100.96,100.6z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.21,
    cy: 102.52,
    r: 1.19
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.77,
    cy: 132.4,
    r: 1.02
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.68,131.26c-0.78,0-1.42,0.63-1.42,1.42c0,0.78,0.63,1.42,1.42,1.42c0.78,0,1.42-0.63,1.42-1.42 C102.1,131.89,101.47,131.26,100.68,131.26z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.42,122.37c-1.08,0-1.95,0.87-1.95,1.95c0,1.08,0.87,1.95,1.95,1.95c1.08,0,1.95-0.87,1.95-1.95 C103.37,123.25,102.5,122.37,101.42,122.37z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.6,116.29c-0.78,0-1.4,0.63-1.4,1.4c0,0.78,0.63,1.4,1.4,1.4c0.78,0,1.4-0.63,1.4-1.4 C99,116.92,98.37,116.29,97.6,116.29z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92.04,
    cy: 107.94,
    r: 1.02
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.39,
    cy: 95.11,
    r: 1.02
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105,110.7c-0.02-1.45,0.6-2.9,1.67-3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSalt);
export default __webpack_public_path__ + "static/media/Table_salt.c798cb3811e0353def8202b26eea6db1.svg";
export { ForwardRef as ReactComponent };